<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="md"
    :modal-title="`대량 학생코드 생성`"
    :confirm="save"
    :close="close"
    confirmButtonTitle="저장"
    :loading="loading"
    name="bulkAccountModal"
  >
    <b-container>
      <b-row class="my-2">
        <input
          type="file"
          ref="fileInput"
          @change="handleFileUpload"
        />
      </b-row>
    </b-container>
  </AdminModal>
</template>

<script>
import api from "@/api/api"
import AdminModal from "@/components/modals/AdminModal.vue";
import Excel from "@/util/excel";

export default {
  name: "BulkAccountModal",
  components: {AdminModal},
  props: ['isOpen', 'reload', 'close', 'lessonAccountOption'],
  data() {
    return {
      file: null,
      lessonAccessAccountOptions: [
        {value: 'REQUEST_CONSULTING', text: '기초반'},
        {value: 'ADVANCED_CLASS', text: '실전반'},
      ],
      lessonId: 0,
      loading: false,
    }
  },
  methods: {
    handleFileUpload(event) {
      const uploadFile = event.target.files[0];

      // Check the file type
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel' // .xls
      ];

      if (!validTypes.includes(uploadFile.type)) {
        this.$toast.show('엑셀 형식만 올릴 수 있습니다.',
          {
            position: "top-right",
            duration: 2000
          });
        event.target.value = null;
        return
      } else {
        this.file = uploadFile
      }
    },
    save() {
      // Check if file is selected
      if (!this.file) {
        this.$toast.show('파일을 선택해주세요.',
          {
            position: "top-right",
            duration: 2000
          });
        return
      }

      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.ms-excel' // .xls
      ];

      if (!validTypes.includes(this.file.type)) {
        this.$toast.show('엑셀 형식만 올릴 수 있습니다.',
          {
            position: "top-right",
            duration: 2000
          });
        return
      }

      this.loading = true
      api.lessonAccesses.createLessonAccessesByExcel(
        {
          lessonId: this.lessonId,
          file: this.file,
          accountType: this.lessonAccountOption
        },
        (response) => {
          Excel.download(response.data, '계정_생성')
          this.reload()
          this.$toast.success('업로드 및 엑셀 다운로드 완료',
            {
              position: "top-right",
              duration: 2000
            })
          this.close()
        }, (e) => {
          console.error(e)
          this.loading = false
          this.$toast.error('업로드 실패',
            {
              position: "top-right",
              duration: 2000,
            });
        })
      
    }
  }
}
</script>

<style scoped>

</style>